import React, { useState } from "react";

import { useTranslation } from 'react-i18next';

import { Col, Row } from "stories/layout"

import { BreadcrumbsDynamic } from 'stories/components';
import TaxForm9A from "views/app/TaxForm9A/TaxForm9A"

const TaxReport = (props) => {
  const { t } = useTranslation();

    //Export button from taxForm9A
    const [exportButton, setExportButton] = useState(null);


  const getCrumbLinks = () => {
    const tail = {
      name: t("tax_report", "Veroilmoitus"),
      url: "/dashboard/reports/tax-report",
    };
    if (props.location?.state?.crumbLinks?.length) {
      return [...props.location.state.crumbLinks, tail];
    }
    return [
      { name: t("Etusivu"), url: "/dashboard/" },
      { name: t("Raportit"), url: "/dashboard/reports" },
      tail,
    ];
  };

  
  return (
    <>

    <Row className="d-flex  flex-wrap  ">
        <Col>
          <BreadcrumbsDynamic links={getCrumbLinks()} />
        </Col>
        <Col md="6" xs="12" className="d-flex flex-column justify-content-end  mr-xs-auto align-self-end mb-3 " style={{minWidth: "50px"}}>
          <div className="ml-auto">
            {exportButton}
          </div>
        </Col>
    </Row>

    <TaxForm9A   setExportButton={setExportButton}/>
    {/*<IncomeReportSummary/ > */}

    </>
  );
}

export default TaxReport;